import { Injectable } from '@angular/core';
import { ZSuiteHelper } from '../helpers/zsuite-helper';
import { UserService } from '@shared/modules/account/services/user.service';
import { ZSuiteService } from './zsuite.service';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  private readonly isZSuite: boolean = false;

  constructor(
    private userService: UserService,
    private zSuiteService: ZSuiteService
  ) {
    this.isZSuite = ZSuiteHelper.isZSuite();
  }

  blankOpen(url: string): void {
    if (this.isZSuite) {
      this.zSuiteService.goToUrl(this.ensureHttps(url));
    } else {
      this.userService.setCookie();
      window.open(this.ensureHttps(url), '_blank');
    }
  }

  selfOpen(url: string, setCookie = true, cookieValue = null): void {
    if (this.isZSuite) {
      this.zSuiteService.goToUrl(this.ensureHttps(url));
    } else {
      if (setCookie) this.userService.setCookie(cookieValue);
      window.open(this.ensureHttps(url), '_self');
    }
  }

  ensureHttps(url: string) {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  }
}
